import { getPokerMin } from '@/components/images/base64/PokerMin';
import { GetTotalBaccaratPoint } from '@/utils/pokerCount';
import { Grid, Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GameResultCellProps } from '..';

export const BaccGameResult = (props: GameResultCellProps) => {
    const { summary } = props;
    const { t } = useTranslation();

    const [resultPlayer, setResultPlayer] = useState<Array<number>>([]);
    const [resultBanker, setResultBanker] = useState<Array<number>>([]);

    useEffect(() => {
        const results = summary.Result.split(',').map(s => Number(s));
        const pIndex = results[0];
        setResultPlayer(results.slice(1, pIndex + 1));
        setResultBanker(results.slice(pIndex + 2, results.length));
    }, [summary]);

    return (
        <>
            <Stack className="item-bacc-game-result-container">
                <DetailResult
                    lbl={t('road.player_win')}
                    lblColor="#3568EE"
                    cards={resultPlayer}
                    point={GetTotalBaccaratPoint(resultPlayer)}
                />
                <DetailResult
                    lbl={t('road.banker_win')}
                    lblColor="#F6444B"
                    cards={resultBanker}
                    point={GetTotalBaccaratPoint(resultBanker)}
                />
            </Stack>
        </>
    );
};

export const DetailResult = ({
    lbl,
    lblColor,
    cards,
    point,
}: {
    lbl: string;
    lblColor: string;
    cards: number[];
    point: number;
}) => {
    return (
        <Stack className="detail-container">
            <Grid item className="detail-left" color={lblColor}>
                {lbl}
            </Grid>
            {cards.map((c, i) => {
                return (
                    <Grid key={`card-${c}-${i}`} item>
                        <Stack direction="row">
                            <Grid item className="card-container">
                                {getPokerMin(c)}
                            </Grid>
                        </Stack>
                    </Grid>
                );
            })}
            <Grid item className="detail-right">
                {point}
            </Grid>
        </Stack>
    );
};
